import { DrillType } from "./drill";
/**
 * ワークメーカーで使用可能なドリルタイプの配列
 */
export var WORK_MAKER_AVAILABLE_DRILL_TYPE = [
    DrillType.SANSU,
    DrillType.CHUGAKU_SUGAKU,
    DrillType.RIKA,
    DrillType.SHAKAI,
    DrillType.CHUGAKU_RIKA,
    DrillType.CHUGAKU_CHIRI,
    DrillType.CHUGAKU_REKISHI,
    DrillType.CHUGAKU_KOUMIN,
];
/**
 * 小学と中学のドリルタイプを区切るライン
 * 既存ドリルフロントでは中学国語のsubjectIdをラインとしているが、subjectで取り扱うことが殆ど無いのでドリルタイプIDにて同等の値を用いる
 */
export var OVER_ELEMENTARY_BORDER_DRILL_TYPE = DrillType.CHUGAKU_KOKUGO;
